/* Boosted Engineering vehicle finder.
   Each generation is ['Label', 'TagToken']. Searches products tagged with the token. */
(function () {
  'use strict';
  function init() {
    var finder = document.querySelector('[data-be-finder]');
    if (!finder) { return; }
    var V = {
      'Toyota': {
        '86 / GR86': [['GT86 / FT86 ZN6 (2012-2021)', 'Toyota86ZN6'], ['GR86 ZN8 (2022+)', 'GR86ZN8']],
        'Supra': [['A90 / A91 GR (B58)', 'SupraA90'], ['A80 (2JZ)', 'SupraA80'], ['A70 (1JZ / 7M / 1G)', 'SupraA70']],
        'GR Yaris': [['GXPA16 (G16E-GTS)', 'GRYarisG16E']],
        'GR Corolla': [['GZEA14 (G16E-GTS)', 'GRCorollaG16E']],
        'Chaser / Cresta / Mark II': [['JZX90 / JZX100 (1JZ-GTE)', 'ChaserJZX100'], ['JZX110 (1JZ-GTE VVTi)', 'ChaserJZX110']],
        'Soarer': [['JZZ30 (1JZ / 2JZ)', 'SoarerJZZ30'], ['UZZ30 (1UZ-FE)', 'SoarerUZZ30']],
        'Aristo': [['JZS147 (2JZ-GTE)', 'AristoJZS147'], ['JZS161 (2JZ-GTE VVTi)', 'AristoJZS161']],
        'Corolla / Sprinter': [['AE86 / AE92 (4A-GE 16V)', 'CorollaAE86'], ['AE101 / AE111 (4A-GE 20V)', 'CorollaAE111']],
        'MR2': [['AW11 (4A-GE 16V)', 'MR2AW11'], ['SW20 (3S-GE / 3S-GTE)', 'MR2SW20']],
        'Celica': [['ST185 / ST205 (3S-GTE)', 'CelicaST205'], ['ST202 (3S-GE)', 'CelicaST202']],
        'Hilux': [['RZN (3RZ-FE)', 'Hilux3RZ'], ['GGN (1GR-FE)', 'Hilux1GR']],
        'LandCruiser': [['80 / 105 Series (1FZ-FE)', 'LandCruiser1FZ']],
        'Aurion / Camry': [['GSV40 / GSV50 (2GR-FE)', 'Aurion2GR']]
      },
      'Lexus': {
        'LS400 / SC400 / GS400': [['UCF10 / UCF20 / UZZ30 (1UZ-FE)', 'Lexus1UZ'], ['UCF20+ VVTi (1UZ / 3UZ)', 'Lexus1UZVVTi']],
        'IS F / RC F': [['USE20 / USC10 (2UR-GSE)', 'Lexus2URGSE']],
        'IS / RC / NX': [['IS XE30 / RC / NX AZ10 (2013+)', 'LexusISRCNX']]
      },
      'Subaru': {
        'BRZ': [['ZC6 (2012-2021)', 'BRZZC6'], ['ZD8 (2022+)', 'BRZZD8']],
        'WRX': [['GC8 (EJ20)', 'WRXGC8'], ['GD (EJ20 / EJ25)', 'WRXGD'], ['VA (FA20DIT)', 'WRXVA'], ['VB (FA24)', 'WRXVB']],
        'WRX STI': [['GC8 (EJ20)', 'STIGC8'], ['GD (EJ207 / EJ257)', 'STIGD'], ['GRB / GVB (EJ207 / EJ257)', 'STIGRB'], ['VA (EJ257)', 'STIVA']],
        'Liberty / Outback': [['BE / BH / BL / BP (EZ30)', 'SubaruEZ30']]
      },
      'Nissan': {
        'Skyline / GT-R': [['R31 (RB20 / RB30)', 'SkylineR31'], ['R32 (RB20DET / RB26DETT)', 'SkylineR32'], ['R33 (RB25DET / RB26DETT)', 'SkylineR33'], ['R34 (RB25DET NEO / RB26DETT)', 'SkylineR34'], ['R35 GT-R (VR38DETT)', 'GTRR35']],
        'Silvia / 180SX / 200SX': [['S13 (SR20DET / CA18DET)', 'SilviaS13'], ['S14 (SR20DET)', 'SilviaS14'], ['S15 (SR20DET)', 'SilviaS15']],
        '240SX': [['S13 / S14 (KA24DE)', 'KA24DE240SX']],
        'Pulsar GTI-R': [['RNN14 (SR20DET)', 'PulsarRNN14']],
        'Pulsar / Primera': [['N15 / P11 (SR16VE / SR20VE)', 'PulsarSR20VE']],
        '350Z / Skyline V35': [['Z33 / V35 (VQ35DE)', 'Z33VQ35']],
        'Patrol': [['Y61 (TB48DE)', 'PatrolY61'], ['Y62 (VK56DE)', 'PatrolY62']],
        'Datsun 1200 / Sunny': [['B110 / B210 (A-Series)', 'DatsunASeries']]
      },
      'Mitsubishi': {
        'Lancer Evolution': [['Evo I - III (4G63)', 'Evo123'], ['Evo IV - VII (4G63)', 'Evo4567'], ['Evo VIII (4G63)', 'Evo8'], ['Evo IX (4G63 MIVEC)', 'Evo9'], ['Evo X (4B11T)', 'EvoX']],
        'Galant VR-4 / Eclipse': [['E39A / D2 (4G63)', 'VR4DSM']]
      },
      'Mazda': {
        'MX-5': [['NA / NB (B6 / BP)', 'MX5NANB'], ['NC (LF-VE)', 'MX5NC']],
        '323': [['BG (B6 Turbo)', 'Mazda323B6']],
        'Mazda3 / Mazda6 MPS': [['BK / BL / GG (L3-VDT)', 'MPSL3VDT']],
        'Mazda3 / Mazda6': [['BK / GG 2.0 (LF-VE)', 'MazdaLFVE']]
      },
      'Honda': {
        'Civic': [['EK / EG Type R (B16A / B18C)', 'CivicEK'], ['EP3 / FN2 / FD2 Type R (K20A)', 'CivicK20A'], ['FK8 / FL5 Type R (K20C1)', 'CivicFK8']],
        'Integra': [['DC2 Type R (B18C)', 'IntegraDC2'], ['DC5 Type R (K20A)', 'IntegraDC5']],
        'Accord': [['CL7 / CL9 (K20A / K24A)', 'AccordCL'], ['CV 2.0T (K20C4)', 'AccordK20C4']]
      },
      'BMW': {
        '1 Series': [['F20', 'F20'], ['F21', 'F21']],
        '2 Series': [['F22', 'F22'], ['F23', 'F23'], ['F45 / F46', 'F45'], ['G42', 'G42']],
        '3 Series': [['F30', 'F30'], ['F31', 'F31'], ['F34', 'F34'], ['G20', 'G20'], ['G21', 'G21']],
        '4 Series': [['F32', 'F32'], ['F33', 'F33'], ['F36', 'F36'], ['G22', 'G22'], ['G23', 'G23'], ['G26', 'G26']],
        '5 Series': [['F10 / F11 / F07 GT', 'F10'], ['G30', 'G30'], ['G31', 'G31']],
        '6 Series': [['F06 / F12 / F13', 'F12'], ['G32 GT', 'G32']],
        '7 Series': [['F01 / F02', 'F01'], ['G11', 'G11'], ['G12', 'G12']],
        '8 Series': [['G14', 'G14'], ['G15', 'G15'], ['G16', 'G16']],
        'X1': [['F48', 'F48']], 'X2': [['F39', 'F39']],
        'X3': [['F25', 'F25'], ['G01', 'G01']], 'X4': [['F26', 'F26'], ['G02', 'G02']],
        'X5': [['F15', 'F15'], ['G05', 'G05']], 'X6': [['F16', 'F16'], ['G06', 'G06']], 'X7': [['G07', 'G07']],
        'Z4': [['G29', 'G29']],
        'M2': [['F87', 'F87'], ['F87 Competition', 'F87'], ['G87', 'G87']],
        'M3': [['F80', 'F80'], ['G80', 'G80'], ['G81 Touring', 'G81']],
        'M4': [['F82', 'F82'], ['F83', 'F83'], ['G82', 'G82'], ['G83', 'G83']],
        'M5': [['F10 M5', 'F10'], ['F90', 'F90']],
        'M6': [['F06 / F12 / F13', 'F12']],
        'M8': [['F91', 'F91'], ['F92', 'F92'], ['F93', 'F93']],
        'X3 M': [['F97', 'F97']], 'X4 M': [['F98', 'F98']],
        'X5 M': [['F85', 'F85'], ['F95', 'F95']],
        'X6 M': [['F86', 'F86'], ['F96', 'F96']]
      },
      'Audi': {
        'A3 / S3 / RS3': [['A3 8V (2013-2020)', 'AudiA38V'], ['S3 8V (EA888 Gen 3)', 'S38V'], ['RS3 8V / 8Y (2.5 TFSI DAZA / DNWA)', 'RS3DAZA']],
        'A4 / S4 / RS4': [['B8.5 / B9', 'AudiA4B9']],
        'A5 / S5 / RS5': [['B8 / B9', 'AudiA5B9']],
        'A6 / S6 / RS6': [['C7', 'AudiA6C7']],
        'TT / TTS / TT RS': [['TT / TTS 8J', 'AudiTT8J'], ['TT / TTS 8S', 'AudiTT8S'], ['TT RS 8S (2.5 TFSI DAZA)', 'TTRS8S']],
        'R8': [['Type 42', 'AudiR842'], ['Type 4S (5.2 V10)', 'R8V10']]
      },
      'Volkswagen': {
        'Golf GTI / R': [['Mk5 (2005-2009)', 'GolfMk5'], ['Mk6 (2009-2013)', 'GolfMk6'], ['Mk7 / Mk7.5 (EA888 Gen 3)', 'GolfMk7']],
        'Scirocco': [['R (2010-2014)', 'SciroccoR']]
      },
      'Porsche': {
        '911': [['991.2 (2016-2019)', 'Porsche9912'], ['992 (2019+)', 'Porsche992']],
        '718 Boxster / Cayman': [['982 (2016+)', 'Porsche718']],
        'Macan': [['95B (2014-2018)', 'PorscheMacan1'], ['95B.2 / 95B.3 (2019-2024)', 'PorscheMacan2']],
        'Cayenne': [['958.2 (2015-2017)', 'PorscheCayenne958']],
        'Panamera': [['971 (2017-2020)', 'PorschePanamera971']]
      },
      'Mercedes-AMG': {
        'A45 AMG': [['W176', 'AMGA45W176']],
        'C43 / C63 AMG': [['W204', 'AMGCW204'], ['W205', 'AMGCW205']],
        'E53 / E63 AMG': [['W211 / W212', 'AMGEW212'], ['W213', 'AMGEW213']],
        'GLC / GLE / GLS AMG': [['GLC43 / 63, GLE43 / 53 / 63, GLS63', 'AMGSUV']]
      }
    };
    /* Added makes, models and generations (Turbosmart range). */
    var ADD = {
      'Subaru': {
        'WRX': [['GR / GV (EJ25, 2008-2014)', 'WRXGR']],
        'Forester XT': [['SF GT (EJ20, 1997-2002)', 'ForesterSF'], ['SG XT (2003-2008)', 'ForesterSG'], ['SH XT (2008-2013)', 'ForesterSH'], ['SJ XT (2013-2018)', 'ForesterSJ']],
        'Liberty / Outback': [['BL / BP GT (2003-2009)', 'LibertyGTBL'], ['BM / BR GT (2009-2014)', 'LibertyGTBM']]
      },
      'Toyota': {
        'Celica': [['ST165 (3S-GTE)', 'CelicaST165']]
      },
      'Nissan': {
        'Patrol': [['GU Y61 (TD42T / ZD30DDTi)', 'PatrolY61TD']],
        'Stagea': [['WC34 (RB25DET)', 'StageaWC34'], ['M35 (VQ25DET / VQ30DET)', 'StageaM35']],
        'Bluebird': [['U12 / U13 4WD (SR20DET)', 'BluebirdSR20']],
        'Juke / Pulsar SSS': [['F15 / C12 (MR16DDT)', 'NissanMR16']]
      },
      'Mitsubishi': {
        'Lancer Ralliart': [['CJ (4B11T)', 'LancerRalliart']]
      },
      'Mazda': {
        'RX-7': [['FC3S S4 / S5 (13B-T)', 'RX7FC'], ['FD3S S6-S8 (13B-REW)', 'RX7FD']],
        'CX-7': [['ER (L3-VDT)', 'CX7L3VDT']],
        'BT-50': [['UP / UR (3.2 TD)', 'BT50UP']]
      },
      'Honda': {
        'Civic': [['FC / FK 10th gen 1.5T (2016-2021)', 'CivicFC']]
      },
      'Suzuki': {
        'Swift Sport / Vitara': [['AZ / LY (K14C Boosterjet)', 'SwiftK14C']]
      },
      'Hyundai': {
        'i30 N / N-Line': [['PD (2017+)', 'i30PD']],
        'Veloster': [['FS Turbo (2011-2017)', 'VelosterFS']],
        'S Coupe': [['Turbo (G4CS)', 'HyundaiSCoupe']]
      },
      'Ford': {
        'Falcon': [['BA / BF XR6 Turbo & F6 (Barra 240T)', 'FalconBABF'], ['FG / FG-X XR6 Turbo & F6 (Barra 270T)', 'FalconFG'], ['FG EcoBoost 2.0L', 'FalconFGEco']],
        'Focus': [['Mk1 RS (2002-2003)', 'FocusMk1RS'], ['Mk2 XR5 / RS (2.5 5cyl)', 'FocusMk2'], ['Mk3 1.6 EcoBoost (2010-2014)', 'FocusMk3Eco'], ['Mk3 ST (2.0 EcoBoost)', 'FocusMk3ST'], ['Mk3 RS (2.3 EcoBoost)', 'FocusMk3RS']],
        'Fiesta': [['ST WZ (1.6 EcoBoost)', 'FiestaSTWZ'], ['1.0 EcoBoost', 'FiestaEco']],
        'Mustang': [['FM / FN 2.3 EcoBoost (2015+)', 'MustangEco']],
        'Ranger': [['PX / PX2 3.2 TD', 'RangerPX'], ['Raptor 3.0 Twin Turbo (2022+)', 'RangerRaptor3']],
        'Explorer': [['3.0 EcoBoost (2020+)', 'Explorer30']],
        'F-150': [['2.7 / 3.5 EcoBoost', 'F150Eco']],
        'F-250 / F-350': [['7.3L Powerstroke', 'Powerstroke73']],
        'Kuga / Mondeo / Galaxy / S-Max': [['1.6 / 2.0 EcoBoost (2010+)', 'FordEcoMisc']],
        'Sierra': [['Cosworth (YB)', 'SierraCosworth']],
        'Laser': [['TX3 (B6T)', 'LaserTX3']]
      },
      'Holden': {
        'Commodore': [['ZB 2.0 Turbo (2017-2020)', 'CommodoreZB']]
      },
      'Jeep': {
        'Wrangler': [['JL / JT 2.0T (2018+)', 'WranglerJL']]
      },
      'Mini': {
        'Cooper S / JCW': [['R55 / R56 / R57 (1.6T)', 'MiniR56']]
      },
      'Volvo': {
        'C30 / C70 / S40 / V50 / S60 / V70': [['T5 (5cyl turbo)', 'VolvoT5']],
        'S60 / V60 / V70 / S80 / V40': [['2010+ turbo models', 'Volvo2010']]
      },
      'Renault': {
        'Megane RS': [['RS250 / RS265 / RS275 (2.0T)', 'MeganeRS3']],
        'Clio RS': [['RS200 / RS220 (1.6T)', 'ClioRS4']]
      },
      'Fiat': {
        '124 Spider / Bravo': [['1.4T MultiAir', 'Fiat14T']],
        '500 / Panda': [['0.9T TwinAir', 'Fiat09T']]
      },
      'Abarth': {
        '124 Spider / Punto / 500': [['1.4T', 'Abarth14T']]
      },
      'Skoda': {
        'Octavia / Superb / Yeti / Rapid': [['TSI models (2005+)', 'SkodaTSI']]
      },
      'Seat': {
        'Leon / Toledo / Altea / Exeo / Alhambra': [['TSI models (2005+)', 'SeatTSI']]
      },
      'BMW': {
        '1 Series': [['E82 135i (N54 / N55)', 'E82']],
        '3 Series': [['E90 / E92 335i (N54 / N55)', 'E90']],
        '5 Series': [['E60 535i / 550i', 'E60']]
      },
      'Audi': {
        'A3 / S3 / RS3': [['A3 / S3 8L (1996-2003)', 'AudiA38L'], ['A3 / S3 / RS3 8P (2004-2013)', 'AudiA38P']],
        'A4 / S4 / RS4': [['B7 / B8 (2005-2015)', 'AudiA4B8']],
        'A6 / S6 / RS6': [['C6 (2005-2011)', 'AudiA6C6']],
        'TT / TTS / TT RS': [['TT 8N (1998-2006)', 'AudiTT8N']],
        'A1 / Q3 / Q5 / A7 / A8': [['TFSI models', 'AudiTFSI']]
      },
      'Volkswagen': {
        'Golf GTI / R': [['Mk4 (1.8T)', 'GolfMk4']],
        'Amarok': [['2H (2.0 TSI / TDI)', 'Amarok2H']],
        'Jetta / Passat / Tiguan / Polo / Beetle': [['TSI / TFSI / 1.8T models', 'VWTSI']]
      },
      'Porsche': {
        '911': [['993 Turbo (1995-1998)', 'Porsche993'], ['996 Turbo / GT2 (2000-2005)', 'Porsche996'], ['997 Turbo / GT2 (2006-2013)', 'Porsche997']]
      },
      'Mercedes-AMG': {
        'A / B / C / E-Class': [['1.6 / 1.8 turbo (M270 / M271)', 'MBM270']]
      }
    };
    Object.keys(ADD).forEach(function (mk) { V[mk] = V[mk] || {}; Object.keys(ADD[mk]).forEach(function (md) { V[mk][md] = (V[mk][md] || []).concat(ADD[mk][md]); }); });
    if (V.Subaru && V.Subaru.WRX && V.Subaru.WRX.length === 5) { var w = V.Subaru.WRX; V.Subaru.WRX = [w[0], w[1], w[4], w[2], w[3]]; }
    var ORDER = ['Toyota', 'Lexus', 'Subaru', 'Nissan', 'Mitsubishi', 'Mazda', 'Honda', 'Suzuki', 'Hyundai', 'Ford', 'Holden', 'Jeep', 'BMW', 'Mini', 'Audi', 'Volkswagen', 'Skoda', 'Seat', 'Porsche', 'Mercedes-AMG', 'Volvo', 'Renault', 'Fiat', 'Abarth'];
    var V2 = {}; ORDER.forEach(function (mk) { if (V[mk]) { V2[mk] = V[mk]; } }); Object.keys(V).forEach(function (mk) { if (!V2[mk]) { V2[mk] = V[mk]; } }); V = V2;
    var swap = function (sel, deep) {
      var el = finder.querySelector(sel);
      var c = el.cloneNode(deep);
      el.parentNode.replaceChild(c, el);
      return c;
    };
    var selMake = swap('[data-be-make]', false);
    var selModel = swap('[data-be-model]', false);
    var selGen = swap('[data-be-gen]', false);
    var go = swap('[data-be-go]', true);
    var fill = function (sel, placeholder, list) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = placeholder;
      sel.appendChild(o);
      list.forEach(function (item, i) {
        var opt = document.createElement('option');
        if (Array.isArray(item)) { opt.value = String(i); opt.textContent = item[0]; }
        else { opt.value = item; opt.textContent = item; }
        sel.appendChild(opt);
      });
    };
    fill(selMake, 'Select make', Object.keys(V));
    fill(selModel, 'Select model', []);
    fill(selGen, 'Select generation', []);
    selMake.addEventListener('change', function () {
      fill(selModel, 'Select model', selMake.value ? Object.keys(V[selMake.value]) : []);
      fill(selGen, 'Select generation', []);
    });
    selModel.addEventListener('change', function () {
      fill(selGen, 'Select generation', selMake.value && selModel.value ? V[selMake.value][selModel.value] : []);
    });
    /* Pre-select the customer's saved car. */
    try {
      var saved = JSON.parse(localStorage.getItem('be-vehicle') || 'null');
      if (saved && V[saved.make] && V[saved.make][saved.model]) {
        selMake.value = saved.make;
        fill(selModel, 'Select model', Object.keys(V[saved.make]));
        selModel.value = saved.model;
        fill(selGen, 'Select generation', V[saved.make][saved.model]);
        if (saved.gen !== undefined && saved.gen !== '') { selGen.value = saved.gen; }
      }
    } catch (e) {}
    var uniq = function (a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); };
    go.addEventListener('click', function () {
      var make = selMake.value, model = selModel.value, tokens = [], label = '';
      if (!make) { return; }
      if (model && selGen.value !== '') {
        var g = V[make][model][parseInt(selGen.value, 10)];
        tokens = [g[1]];
        label = make + ' ' + model + ' ' + g[0];
      } else if (model) {
        tokens = V[make][model].map(function (g) { return g[1]; });
        label = make + ' ' + model;
      } else {
        tokens = [make];
        label = make;
      }
      tokens = uniq(tokens);
      var q = tokens.map(function (t) { return 'tag:' + t; }).join(' OR ');
      var url = '/search?type=product&q=' + encodeURIComponent(q) + '&vehicle=' + encodeURIComponent(label);
      /* Remember the car so shop pages can offer "Show parts that fit". */
      if (model) {
        try { localStorage.setItem('be-vehicle', JSON.stringify({ label: label, tokens: tokens, url: url, make: make, model: model, gen: selGen.value })); } catch (e) {}
      }
      window.location.href = url;
    });
  }
  /* Deferred scripts run before be.js finishes, so wait for DOMContentLoaded. */
  if (document.readyState === 'complete') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
